module.exports = __webpack_public_path__ + "img/favicon-128.f83fc520.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon-128.png
// module id = xd6I
// module chunks = 0